import type { BFFArticleBodyElement } from "@src/app/types/bff";

import ArticleAnnotation from "./components/ArticleAnnotation";

export default function ArticleParagraph({
  element,
}: {
  element: BFFArticleBodyElement["paragraph"];
}) {
  return (
    <p className="pb-5 text-justify text-body-1 text-primary">
      <ArticleAnnotation
        value={element.value}
        annotations={element.annotations}
      />
    </p>
  );
}
